import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

// Canonical destructive banner (the 7 hand-rolled boxes) + the amber warning
// sibling. ALWAYS renders role="alert" — this restores the a11y role on the
// three sites that had dropped it (approvals/List, approvals/Show, users/Memory).
const alertVariants = cva('rounded-md border px-3 py-2 text-sm', {
  variants: {
    variant: {
      destructive: 'border-destructive/50 bg-destructive/10 text-destructive',
      warning: 'border-amber-500/50 bg-amber-500/10 text-amber-700',
    },
  },
  defaultVariants: { variant: 'destructive' },
});

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

export function Alert({ className, variant, ...props }: AlertProps) {
  return <div role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

export { alertVariants };
